import { createInMemoryAtom } from '@exodus/atoms'
import { isNumberUnit } from '@exodus/currency'
import { deserialize, serialize } from '@exodus/models/lib/account-state/serialization.js'
// eslint-disable-next-line no-restricted-imports -- TODO: Fix this the next time the file is edited.
import lodash from 'lodash'

const { cloneDeepWith } = lodash

export const serializeBalances = (data) =>
  cloneDeepWith(data, (val) => {
    if (val && isNumberUnit(val)) return serialize(val)
  })

export const deserializeBalances = (data) =>
  cloneDeepWith(data, (val) => {
    if (val?.t === 'numberunit') return deserialize(val)
  })

// eslint-disable-next-line @exodus/hydra/in-memory-atom-default-value
const createSyncedBalancesAtom = () => createInMemoryAtom()

export default createSyncedBalancesAtom
